import BaseEnumType from "../../common/base-enum-type";

const TiebreakType = Object.freeze({
    SevenPoints: { ...new BaseEnumType("1", "7 Points"), value: 1, points: 7 },
    TenPoints: { ...new BaseEnumType("2", "10 Points"), value: 2, points: 10 },
    ThirteenPoints: {
        ...new BaseEnumType("3", "13 Points"),
        value: 3,
        points: 13
    }
});

export default TiebreakType;
